import { render, staticRenderFns } from "./JobMatchingSetting.vue?vue&type=template&id=5d87d18a"
import script from "./JobMatchingSetting.vue?vue&type=script&lang=js"
export * from "./JobMatchingSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports